import { render, staticRenderFns } from "./BrandingMarketing.vue?vue&type=template&id=2228d4e3&scoped=true&"
import script from "./BrandingMarketing.vue?vue&type=script&lang=js&"
export * from "./BrandingMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228d4e3",
  null
  
)

export default component.exports